(function () {
  /**
   * ADR-200 «بطاقة رصيد إيروس» — the pieces every page needs
   * (docs/decisions/adr-200-gift-credit-cards.md):
   *
   * 1. window.ErosGiftCredit — shared helpers for the wallet screen
   *    (eros-account-wallet.js), the checkout sheet (eros-checkout.js) and
   *    the orders page: which variants are gift credit (from
   *    GET /v1/gift-credit/config), code normalising, strings.
   * 2. Cards and products may share one cart (owner 2026-10-02, ADR-200
   *    «Change — cards and products in one cart»). The «تُشترى وحدها» add-to-
   *    cart guard that lived here is gone; any cart holding a card pays
   *    online only, with no discount or wallet — eros-checkout.js applies
   *    that, and the worker enforces it at confirm.
   *
   * Loaded site-wide from layout/theme.liquid (defer, after
   * eros-commerce-client.js and eros-commerce-ui.js).
   */

  var STR = (window.ErosAccountStrings && window.ErosAccountStrings.wallet) || {};

  /** t('key', 'fallback', { amount: '25,000' }) — replaces {name} placeholders. */
  function t(key, fallback, vars) {
    var s = STR[key] || fallback;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(String(vars[k]));
      });
    }
    return s;
  }

  var CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  var CODE_LENGTH = 16;

  /** Same rules as the worker's normalizeGiftCode: digits, case, spaces and dashes. */
  function normaliseCode(raw) {
    return String(raw || '')
      // Arabic-Indic (U+0660–0669) and Persian (U+06F0–06F9) digits: the low
      // nibble of each code point is the digit itself.
      .replace(/[\u0660-\u0669\u06F0-\u06F9]/g, function (d) {
        return String(d.charCodeAt(0) & 0xf);
      })
      .toUpperCase()
      .replace(/[\s\-_.\u2010-\u2015\u2212]/g, '');
  }

  function isValidCode(normalised) {
    if (!normalised || normalised.length !== CODE_LENGTH) return false;
    for (var i = 0; i < normalised.length; i++) {
      if (CODE_ALPHABET.indexOf(normalised.charAt(i)) === -1) return false;
    }
    return true;
  }

  function formatCode(code) {
    var s = String(code || '');
    return (s.match(/.{1,4}/g) || [s]).join('-');
  }

  /** 25000 → "25,000" (the strings carry their own currency word). */
  function formatAmount(n) {
    var v = Math.round(Math.abs(Number(n) || 0));
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function toVariantGid(id) {
    var s = String(id == null ? '' : id).trim();
    if (!s) return '';
    return s.indexOf('gid://') === 0 ? s : 'gid://shopify/ProductVariant/' + s;
  }

  function config() {
    if (!window.ErosCommerce || !window.ErosCommerce.giftCreditConfig) {
      return Promise.resolve({ enabled: false, products: [], paymentChipIds: [], productHandle: null });
    }
    return window.ErosCommerce.giftCreditConfig();
  }

  function isGiftVariant(cfg, variantId) {
    var gid = toVariantGid(variantId);
    if (!gid || !cfg || !cfg.products) return false;
    for (var i = 0; i < cfg.products.length; i++) {
      if (cfg.products[i].variantGid === gid) return true;
    }
    return false;
  }

  /** 'none' | 'gift' | 'mixed' — mirrors the worker's classifyGiftCart. */
  function cartKind(cfg, variantIds) {
    var ids = variantIds || [];
    var gift = 0;
    ids.forEach(function (id) {
      if (isGiftVariant(cfg, id)) gift++;
    });
    if (gift === 0) return 'none';
    return gift === ids.length ? 'gift' : 'mixed';
  }

  /** The worker's gift-checkout refusals, in the customer's words; null for anything else. */
  function checkoutErrorMessage(code) {
    switch (code) {
      case 'gift_credit_disabled':
        return t('err_disabled', 'بطاقات الرصيد غير متاحة حالياً');
      case 'gift_credit_payment_method':
        return t('err_payment_method', 'بطاقة الرصيد تُدفع بالبطاقة أو الحوالة');
      case 'gift_credit_no_discounts':
        return t('err_no_discounts', 'لا تُطبَّق الخصومات على بطاقة الرصيد');
      default:
        return null;
    }
  }

  window.ErosGiftCredit = {
    t: t,
    config: config,
    isGiftVariant: isGiftVariant,
    cartKind: cartKind,
    toVariantGid: toVariantGid,
    normaliseCode: normaliseCode,
    isValidCode: isValidCode,
    formatCode: formatCode,
    formatAmount: formatAmount,
    checkoutErrorMessage: checkoutErrorMessage,
    ORDER_TAG: 'eros-gift-credit',
  };
})();
